import P from 'helpers/predicates'
import {
  combineReducers
} from 'redux'

import {
  createReducer
} from 'helpers/ReducerUtil'

import {
  CLEAR_USER_ATTRIBUTES,
  UPDATE_AUTHENTICATED,
  UPDATE_USER_USERNAME,
  UPDATE_USER_PASSWORD,
  UPDATE_USER_PROFILE,
  UPDATE_USER_ID,
  CLEAR_USER_ID,
  CLEAR_SHOW_ERROR,
  UPDATE_SHOW_ERROR
} from './constants'

const updateUserId = (prev, { id }) => P.isNotNil(id)
  ? id
  : prev

const updateUsername = (prev, { username }) => P.isNotNil(username)
  ? username
  : prev

const updatePassword = (prev, { password }) => P.isNotNil(password)
  ? password
  : prev

const updateEmail = (prev, { email }) => P.isNotNil(email)
  ? email
  : prev

const updateName = (prev, { name }) => P.isNotNil(name)
  ? name
  : prev

const updateAuthenticated = (prev, { authenticated }) => P.isNotNil(authenticated)
  ? authenticated
  : prev

const updateShowError = (prev, { show }) => P.isNotNil(show)
  ? show
  : prev
const updateCustomViews = (prev, { customViews }) => P.isNotNil(customViews)
  ? customViews
  : prev

const updateDefaultView = (prev, { defaultView }) => P.isNotNil(defaultView)
  ? defaultView
  : prev
  
const clearShowError = () => false
const clearString = () => ''
const clearUserId = () => null
const clearPassword = clearString
const clearUsername = clearString
const clearName = clearString
const clearEmail = clearString
const clearAuthenticated = () => false

const id = createReducer(null, {
  [CLEAR_USER_ATTRIBUTES]: clearUserId,
  [CLEAR_USER_ID]: clearUserId,
  [UPDATE_USER_ID]: updateUserId
})

const username = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: clearUsername,
  [UPDATE_USER_USERNAME]: updateUsername,
  [UPDATE_USER_PROFILE]: updateUsername,
})

const password = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: clearPassword,
  [UPDATE_USER_PASSWORD]: updatePassword
})

const authenticated = createReducer(false, {
  [CLEAR_USER_ATTRIBUTES]: clearAuthenticated,
  [UPDATE_AUTHENTICATED]: updateAuthenticated,
})

const name = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: clearName,
  [UPDATE_USER_PROFILE]: updateName,
})

const email = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: clearEmail,
  [UPDATE_USER_PROFILE]: updateEmail,
})

const profile = createReducer(false, {
  [CLEAR_USER_ATTRIBUTES]: () => false,
  [UPDATE_USER_PROFILE]: () => true,
})

const showError = createReducer(false, {
  [CLEAR_SHOW_ERROR]: clearShowError,
  [UPDATE_SHOW_ERROR]: updateShowError,
})

const customViews = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: () => '',
  [UPDATE_USER_PROFILE]: updateCustomViews
})

const defaultView = createReducer('', {
  [CLEAR_USER_ATTRIBUTES]: () => '',
  [UPDATE_USER_PROFILE]: updateDefaultView
})
export default combineReducers({
  id,
  password,
  username,
  authenticated,
  email,
  name,
  profile,
  showError,
  customViews,
  defaultView
})
